import { defineComponent as _defineComponent } from 'vue'
import {
        defineComponent, computed,
    } from 'vue';
    import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
    import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import ToggleListContent from '@ve/components/filters/common/components/toggleListContent/ToggleListContent.vue';
    import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
    import { IHotel } from '@entities/hotel';
    import { ITouristGroup, isTouristGroupHasChilds } from '@entities/touristGroup';
    import { childServiceFilterMethods } from '../../lib/ChildServiceFilterMethods';
    import useFilterHotelsModel from '../../lib/useFilterHotelsModel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopChildServiceFilter',
  props: {
    filteredHotels: { default: () => [] },
    allHotels: { default: () => [] },
    touristGroup: null,
    visibleCounter: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { filteredHotels: IHotel[], allHotels: IHotel[], touristGroup: ITouristGroup, visibleCounter: boolean }

    defineComponent({ name: 'ServiceChildFilter' });

    

    const { childServiceFilter } = useFilterHotelsModel();

    const isSomeHotelHasChildService = computed(() => childServiceFilterMethods.isSomeHotelHasChildService(props.allHotels));

    const { toggleAttributeHandler, takenAttributeHandler } = useFilterAttributesAnalytics(childServiceFilterMethods);


return { __sfc: true,props, childServiceFilter, isSomeHotelHasChildService, toggleAttributeHandler, takenAttributeHandler, FiltersListSection, ToggleListContent, FilterListRender, isTouristGroupHasChilds, childServiceFilterMethods }
}

})